import { useMemo } from "react"
import { TableCell, TableRow, Typography } from "@mui/material"
import { Repeat } from "lib/@components/repeat"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { Bound } from "lib/@components/binding/Bound"
import { ComparisonTradeBreakdownCell } from "./comparison-trade-breakdown-cell"

export function ComparisonTradeBreakdownRow({ tradeName }) {
    const { variants } = useBoundContext()
    const lowestCost = useMemo(getLowestCost, [tradeName, variants])

    return (
        <TableRow data-cy="comparison-trade-row">
            <TableCell>
                <Typography variant="body2">{tradeName}</Typography>
            </TableCell>
            <Bound tradeName={tradeName} lowestCost={lowestCost}>
                <Repeat list={variants} item={<ComparisonTradeBreakdownCell />} />
            </Bound>
        </TableRow>
    )

    function getLowestCost() {
        let min = Infinity
        let count = 0
        for (const v of variants) {
            const trade = (v?.costResult?.tradeBreakdown ?? []).find(isMatchingTrade)
            if (!trade) continue
            if (trade.totalCost < min) {
                min = trade.totalCost
                count = 1
            } else if (trade.totalCost === min) {
                count++
            }
        }
        if (min === Infinity) return null
        if (count > 1) return null
        return min
    }

    function isMatchingTrade(t) {
        return t.tradeName === tradeName
    }
}
